import axios from 'axios';
//import * as VUEAXIOSPLUGIN from 'vue-axios-plugin';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';

class FluxCMS{
    constructor(
        {
            app_id = 'ElementsAustellung', // decormetallShowroom, HallePanoTour, HSEmdenLeer, ElementsAustellung
            app_secret = 'elementsAustellung2020', // decormetallShowroom2020, hallePanoTour2020, HSEmdenLeerChemie, elementsAustellung2020
            baseURL = 'https://rt-ar-app.ar-cms.de',
            worldsPath = '/getAllWorldsForUser',
            projectsPath = '/getAllArProjectsOfWorldForUser/',
            zipPath = '/getBuildZipFile/',
            rawContentFilePath = '/getRawContentFile/',
            rawContentFileURLPath = '/flux/api/media/RawContent/url/get/',
        } = {}
    ) {
        this.baseURL = baseURL;
        this.worldsPath = worldsPath;
        this.projectsPath = projectsPath;
        this.zipPath = zipPath;
        this.rawContentFilePath = rawContentFilePath;
        this.rawContentFileURLPath = rawContentFileURLPath;

        this.setAppInformation( app_id, app_secret );
    }

    get worldsURL() {
        return this.baseURL + this.worldsPath;
    }

    get projectsURL() {
        return this.baseURL + this.projectsPath;
    }

    get rawContentFileURL() {
        return this.baseURL + this.rawContentFilePath;
    }

    get rawContentFileURLURL() {
        return this.baseURL + this.rawContentFileURLPath;
    }

    get zipURL() {
        return this.baseURL + this.zipPath;
    }

    setAppInformation( app_id, app_secret ) {
        this.app_id = app_id;
        this.app_secret = app_secret;
        this.axios_app_instance = axios.create({
            headers: {'X-APP-TOKEN': this.app_secret, 'Content-Type': 'application/json'}
        });
        this.post_data = {'appId': this.app_id, 'appSecret': this.app_secret }
    }

    getWorlds() {
        var fluxCMS = this;
        return new Promise( function( resolve, reject ) {
            console.log("FluxCMS::getWorlds: " + fluxCMS.worldsURL );
            console.log("post_data: " + fluxCMS.post_data.appId + " -> " + fluxCMS.post_data.appSecret );
            //this.post_data = {'appId': this.app_id, 'appSecret': this.app_secret }
            fluxCMS.axios_app_instance.get(fluxCMS.worldsURL, fluxCMS.post_data).then((response) => {
                console.log(response.data.content);
                resolve( response.data.content);
            }).catch(function (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    reject(Error(error.response))
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
                reject(Error(error.request))
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
                reject(Error(error.message))
            }
                console.log(error.config);
            });
        });
    }

    getProjects( projectID ) {
        var fluxCMS = this;
        return new Promise( function( resolve, reject ) {
            console.log("FluxCMS::getProjects: " + fluxCMS.projectsURL + projectID );
            console.log("post_data: " + fluxCMS.post_data.appId + " -> " + fluxCMS.post_data.appSecret );
            //this.post_data = {'appId': this.app_id, 'appSecret': this.app_secret }
            fluxCMS.axios_app_instance.get(fluxCMS.projectsURL + projectID, fluxCMS.post_data).then((response) => {
                console.log(response.data.content);
                resolve( response.data.content);
            }).catch(function (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    reject(Error(error.response))
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
                reject(Error(error.request))
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
                reject(Error(error.message))
            }
                console.log(error.config);
            });
        });
    }

    async getZIP( projectID, preview ) {
        const url=`${this.zipURL}${projectID}${preview ? "?preview=true" : ""}`;
        const {promisify} = require('util');
        const getBinaryContent = promisify(JSZipUtils.getBinaryContent);
        const data = await getBinaryContent(url);
        return JSZip.loadAsync(data);
    }

    getRawContentFile( rawContentFileID ) {
        var fluxCMS = this;
        return new Promise( function( resolve, reject ) {
            console.log("FluxCMS::getRawContentFile: " + fluxCMS.rawContentFileURL + rawContentFileID );
            fluxCMS.axios_app_instance.get(fluxCMS.rawContentFileURL + rawContentFileID).then((response) => {
                //console.log(response.data.content);
                resolve( response.data.content);
            }).catch(function (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    reject(Error(error.response))
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
                reject(Error(error.request))
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
                reject(Error(error.message))
            }
                console.log(error.config);
            });
        });
    }

    getRawContentFileURL( rawContentFileID ) {
        return this.rawContentFileURL + rawContentFileID;
    }

    getRawContentFileURLURL( rawContentFileID ) {
        var fluxCMS = this;
        return new Promise( function( resolve, reject ) {
            console.log("FluxCMS::getRawContentFileURLURL: " + fluxCMS.rawContentFileURLURL + rawContentFileID );
            fluxCMS.axios_app_instance.get(fluxCMS.rawContentFileURLURL + rawContentFileID).then((response) => {
                //console.log(response);
                console.log("=>" + response.data.content.url);
                resolve( response.data.content.url );
            }).catch(function (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    reject(Error(error.response))
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                    reject(Error(error.request))
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                    reject(Error(error.message))
                }
                console.log(error.config);
            });
        });
    }
}

// Exports
export default FluxCMS;
export { FluxCMS };
